(function () {
    XonBoard.DynamicForm = {

        uuid: function () {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        /**
         * https://github.com/alpinejs/alpine/discussions/1635
         */
        form_data: function (as, initial) {
            var initial_rows = initial || [];

            initial_rows = initial_rows.map(function (item) {
                item.id = XonBoard.DynamicForm.uuid();
                return item;
            });

            return {
                as: as,
                initial_rows: initial_rows,
                rows: initial_rows,
                // workaround as sorting does not work properly
                s: 1,
                empty_row() {
                    return {
                        id: XonBoard.DynamicForm.uuid(),
                        sort: this.last_index() + this.s,
                    };
                },
                last_index() {
                    return (this.rows || []).length;
                },
                reset() {
                    this.rows = this.initial_rows;
                },
                setRows(rows) {
                    this.rows = rows;
                },
                init() {
                    var self = this;
                    document.addEventListener('create-modal-closed', function () {
                        self.reset();
                        XonBoard.Utils.Select2.reset();
                    });

                    Sortable.create(this.$refs.table_body, {
                        handle: '.drag_handle',
                        onEnd: (event) => {
                            let rows = Alpine.raw(this.rows);
                            let data = rows[event.oldIndex];

                            rows.splice(event.oldIndex, 1);
                            rows.splice(event.newIndex, 0, data);

                            this.apply_order(rows);
                        }
                    })
                },
                apply_order(rows) {
                    rows = rows.map((element, index) => {
                        element.sort = this.s + index;
                        return element;
                    });

                    this.s += rows.length;
                    if (this.s > rows.length * 3) {
                        this.s = 0;
                    }

                    this.setRows(rows);
                },
                move_row(id, direction) {
                    const rows = [...Alpine.raw(this.rows)];
                    const from = this.row_index(id);
                    const to = from + direction;

                    if (to < 0 || to >= rows.length) {
                        return;
                    }

                    rows.splice(to, 0, rows.splice(from, 1)[0]);
                    this.apply_order(rows);
                },
                row_index(id) {
                    let index = 0
                    for (let row of this.rows) {
                        if (row.id === id) break; else index++
                    }
                    return index
                },
                add_row() {
                    this.rows.push(this.empty_row())
                },
                insert_row(i) {
                    this.rows.splice(i + 1, 0, this.empty_row())
                },
                remove_row(id) {
                    this.rows.splice(this.row_index(id), 1)
                }
            };
        }
    }
})();
